import { render, staticRenderFns } from "./serveForm.vue?vue&type=template&id=28d1ff8c&scoped=true&"
import script from "./serveForm.vue?vue&type=script&lang=js&"
export * from "./serveForm.vue?vue&type=script&lang=js&"
import style0 from "./serveForm.vue?vue&type=style&index=0&id=28d1ff8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1ff8c",
  null
  
)

export default component.exports